import PpSelect from '@/components/Selectors/Select';
import AlbumItem from '../AlbumItem';
import PopupSelected from '../PopupSelected';
import { scrollToElement } from '@/common/utils';
import { get } from 'lodash';

export default {
  components: {
    PpSelect,
    AlbumItem,
    PopupSelected
  },
  props: {
    selectedMedia: {
      type: Array,
      default: () => []
    },
    portraitDropdowns: {
      type: Array,
      required: true
    },
    folders: {
      type: Array,
      default: () => []
    },
    selectedFolder: {
      type: Object,
      required: true
    }
  },
  computed: {
    isShowPopupSelected() {
      return this.selectedMedia.length !== 0;
    }
  },
  watch: {
    folders() {
      const el = get({ refs: this.$refs }, 'refs["album-0"][0].$el');
      if (!el) return;

      scrollToElement(el, { behavior: 'auto', block: 'start' });
    }
  },
  methods: {
    onChangeFolder(data) {
      this.$emit('changeFolder', data);
    },
    onSelectedMedia(image) {
      this.$emit('change', image);
    }
  }
};
